<template>
  <v-progress-circular
    v-if="isLoading"
    :size="70"
    :width="7"
    color="primary"
    indeterminate
    class="centered"
  ></v-progress-circular>
  <div v-else>
    <h1 class="text-center mt-3">{{ form.type }}</h1>
    <div class="form shadow p-5 mb-5 bg-white rounded">
      <div class="row">
        <div class="offset-10 col-2">
          <label for="selectedLanguage">Language</label>
          <multiselect
            id="selectedLanguage"
            v-model="langSelect"
            :options="[{ text: 'TH' }, { text: 'EN' }]"
            label="text"
            track-by="text"
          >
          </multiselect>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <label :for="'detail_' + langSelect.text"
            >Detail ({{ langSelect.text }})</label
          >
          <div v-show="langSelect.text === 'TH'">
            <CkEditor
              id="detail_TH"
              :value="form.detailTh"
              :isTh="true"
              @setContent="setContent"
            ></CkEditor>
            <div v-if="isSubmit && error.errorDetailTh" class="text-error">
              {{ error.errorDetailTh.message }}
            </div>
          </div>
          <div v-show="langSelect.text === 'EN'">
            <CkEditor
              id="detail_EN"
              :value="form.detailEn"
              :isTh="false"
              @setContent="setContent"
            ></CkEditor>
            <div v-if="isSubmit && error.errorDetailEn" class="text-error">
              {{ error.errorDetailEn.message }}
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-end mt-5">
        <router-link
          :to="{ name: 'TermsAndConditions' }"
          class="btn btn-outline-danger btn-cancel ml-10"
          >Cancel</router-link
        >
        <button class="btn btn-outline-success ml-10" @click="onSubmit">
          Save
        </button>
      </div>
      <v-dialog v-model="showDialog" width="500" persistent>
        <div class="content-dialog">
          <h3>{{ message }}</h3>
          <div class="row text-center">
            <div v-if="showSuccess && id" class="col-12">
              <button class="btn-back" @click="setDefault">ตกลง</button>
            </div>
            <div v-if="showSuccess" class="col-12">
              <button
                class="btn-back"
                @click="() => $router.push({ name: 'TermsAndConditions' })"
              >
                กลับสู่หน้าหลัก
              </button>
            </div>
          </div>
          <div v-if="!showSuccess" class="row text-center">
            <div class="col">
              <button class="btn-back" @click="showDialog = false">ปิด</button>
            </div>
          </div>
        </div>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import CkEditor from "components/CkEditor/CkEditor.vue";
import TermsAndConditionsService from "services/api/termsAndConditions.service";

export default {
  components: { CkEditor },
  data() {
    return {
      id: this.$route.query.id,
      message: "",
      showDialog: false,
      isLoading: true,
      isSubmit: false,
      showSuccess: false,
      langSelect: { text: "TH" },
      form: {
        detailTh: null,
        detailEn: null,
        type: null,
      },
      error: {
        errorDetailTh: null,
        errorDetailEn: null,
      },
    };
  },
  mounted() {
    this.getTermsAndConditions();
  },
  methods: {
    onSubmit() {
      this.isSubmit = true;
      this.isLoading = true;
      this.resetErrorText();
      const form = this.form;
      const body = {
        detailTh: form.detailTh,
        detailEn: form.detailEn,
      };

      this.updateTermsAndConditions(body);
    },
    async updateTermsAndConditions(body) {
      await TermsAndConditionsService.updateTermsAndConditions(body, this.id)
        .then(async (res) => {
          const data = res.data;
          await this.getTermsAndConditions();
          this.isLoading = false;
          this.showDialog = true;
          this.showSuccess = true;
          this.message = data.message
            ? data.message
            : "Save Terms and Conditions success";
        })
        .catch((err) => {
          this.isLoading = false;
          const errorData = err.response?.data;
          if (errorData?.message) {
            this.showDialog = true;
            this.message = errorData.message;
          }
          if (errorData.errors?.length > 0) {
            this.setErrorText(errorData.errors);
          }
        });
    },
    async getTermsAndConditions() {
      await TermsAndConditionsService.getDetailTermsAndConditions(this.id)
        .then((res) => {
          const data = res.data;
          this.isLoading = false;
          const form = this.form;
          form.type = data.friendlyName.includes("Privacy Statement") ? data.friendlyName : `${data.friendlyName} Terms and Conditions`;
          form.detailTh = data.detailTh;
          form.detailEn = data.detailEn;
        })
        .catch((err) => {
          this.isLoading = false;
          const errorData = err.response?.data;
          if (errorData?.message) {
            this.showDialog = true;
            this.message = errorData.message;
          }
        });
    },
    setContent(content, isTh = true) {
      if (isTh) {
        this.form.detailTh = content || "";
      } else {
        this.form.detailEn = content || "";
      }
    },
    setErrorText(errors) {
      this.error.errorDetailTh = errors.find((e) => e.fieldName === "detailTh");
      this.error.errorDetailEn = errors.find((e) => e.fieldName === "detailEn");
    },
    resetErrorText() {
      this.error.errorDetailTh = null;
      this.error.errorDetailEn = null;
    },
    setDefault() {
      this.showDialog = false;
      this.isSubmit = false;
      this.showSuccess = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.btn-cancel {
  color: red;

  .btn-cancel:hover {
    color: white;
  }
}
</style>
